let _region = 'US';

/** Called by psapInfoListener once the PSAP resolves. */
export function configureMapsRegion(region: string) {
  _region = region;
}

/**
 * The agency's alpha-2 country for the Google Maps loader URL's `region` param,
 * defaulting to US until the PSAP resolves. For the non-component loaders that
 * have no store access. React callers should use usePSAPCountryAlpha2 instead.
 */
export function getMapsRegion() {
  return _region;
}
